// extracted by mini-css-extract-plugin
export default {"loader":"LoadingAnimation_loader__vM5mk","loader__element":"LoadingAnimation_loader__element__Ofu1n","preloader":"LoadingAnimation_preloader__ur6xz"};